import {ImageLoader} from 'next/image'

// https://kontent.ai/learn/learn/docs/apis/image-transformation-api

export const loadImageFromKontentAI: ImageLoader = ({src, width, quality}) => {
	return `${src}?w=${width}&q=${quality ?? 75}&auto=format`
}
